import axios from "axios";
import {
  CREATEOFFER_REQUEST,
  CREATEOFFER_SUCCESS,
  CREATEOFFER_FAIL,
  DELETEOFFER_REQUEST,
  DELETEOFFER_SUCCESS,
  DELETEOFFER_FAIL,
  GETOFFER_REQUEST,
  GETOFFER_SUCCESS,
  GETOFFER_FAIL,
  UPDATEOFFER_REQUEST,
  UPDATEOFFER_SUCCESS,
  UPDATEOFFER_FAIL,
  baseURL,
} from "./types";

// Utility to get the auth token from local storage
const getAuthToken = () => {
  const loginData = JSON.parse(localStorage.getItem("loginData") || "{}");
  return loginData.token || "";
};

// Create Offer
export const createOffer = (data) => async (dispatch) => {
  try {
    dispatch({ type: CREATEOFFER_REQUEST });

    const token = getAuthToken();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    console.log("Sending offer data:", data); // Log outgoing data

    const response = await axios.post(
      `${baseURL}/api/appointmentOffers/create`,
      data,
      config
    );

    console.log("Create Offer response:", response.status, response.data); // Log response

    dispatch({ type: CREATEOFFER_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    console.error("Create Offer error:", error.response || error.message);
    dispatch({
      type: CREATEOFFER_FAIL,
      payload: error.response?.data?.message || error.message,
    });
    throw error;
  }
};

// Get Offers
export const getOffer = (data) => async (dispatch) => {
  try {
    dispatch({ type: GETOFFER_REQUEST });

    const token = getAuthToken();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${baseURL}/api/appointmentOffers/getall`,
      data,
      config
    );

    dispatch({ type: GETOFFER_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({
      type: GETOFFER_FAIL,
      payload: error.response?.data?.message || error.message,
    });
    throw error;
  }
};

// Update Offer
export const updateOffer = (data) => async (dispatch) => {
  try {
    dispatch({ type: UPDATEOFFER_REQUEST });

    const token = getAuthToken();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.patch(
      `${baseURL}/api/appointmentOffers/update`,
      data,
      config
    );

    dispatch({ type: UPDATEOFFER_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({
      type: UPDATEOFFER_FAIL,
      payload: error.response?.data?.message || error.message,
    });
    throw error;
  }
};

// Delete Offer
export const deleteOffer = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETEOFFER_REQUEST });

    const token = getAuthToken();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: { id }, // pass ID in request body
    };

    const response = await axios.delete(
      `${baseURL}/api/appointmentOffers/delete`,
      config
    );

    // Dispatch with the deleted ID to update the store properly
    dispatch({ type: DELETEOFFER_SUCCESS, payload: { id } });

    return response.data;
  } catch (error) {
    dispatch({
      type: DELETEOFFER_FAIL,
      payload: error.response?.data?.message || error.message,
    });
    throw error;
  }
};
